/**
 * Softeq Development Corporation
 * https://www.softeq.com
 */

import { NgModule } from '@angular/core';
import {
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatPaginatorModule,
} from '@angular/material';

const matModules = [
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatPaginatorModule,
];

@NgModule({
  imports: matModules,
  exports: matModules,
})
export class MaterialModule {
}
